import * as braze from '@braze/web-sdk';
import {ApiUserProfile} from '@shareland/shareland-common';

export const updateBrazeUserFromUserProfile = (userProfileLogin: ApiUserProfile['login']['resBody']['data']) => {
  const brazeUser = braze.getUser();
  if (!brazeUser) return;

  if (userProfileLogin.countryCode) {
    brazeUser.setCountry(userProfileLogin.countryCode);
  }

  if (userProfileLogin.email) {
    brazeUser.setEmail(userProfileLogin.email);
  }

  if (userProfileLogin.phoneNumber) {
    brazeUser.setPhoneNumber(userProfileLogin.phoneNumber);
  }

  if (userProfileLogin.displayName) {
    brazeUser.setCustomUserAttribute('displayName', userProfileLogin.displayName);
  }

  if (userProfileLogin.createdAt) {
    brazeUser.setCustomUserAttribute('createdAt', new Date(userProfileLogin.createdAt));
  }

  if (userProfileLogin.updatedAt) {
    brazeUser.setCustomUserAttribute('updatedAt', new Date(userProfileLogin.updatedAt));
  }

  brazeUser.setCustomUserAttribute('account', userProfileLogin.account.toLowerCase());

  brazeUser.setCustomUserAttribute('hasAvatar', !!userProfileLogin.avatarUrl);

  brazeUser.setCustomUserAttribute('displayInFiat', userProfileLogin.displayInFiat);
};
